import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (typeof FS === "undefined") return
    this.tryCapture(0)
  }

  tryCapture(attempt) {
    if (attempt > 20) return
    if (typeof FS === "undefined" || typeof FS.getCurrentSessionURL !== "function") {
      setTimeout(() => this.tryCapture(attempt + 1), 250)
      return
    }
    const sessionUrl = FS.getCurrentSessionURL()
    if (!sessionUrl || !this.urlValue) return
    patch(this.urlValue, {
      body: { fullstory_session: { url: sessionUrl } },
      contentType: "application/json"
    })
  }
}
